/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getAppMessageTemplatesApp} from '../api'

 export const useQueryGetAppMessageTemplatesApp = createReactQueryHook('getAppMessageTemplatesApp', getAppMessageTemplatesApp)
